<template>
  <div>

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      style="box-shadow: 0px 2px 20px 0px #105c8e26"
      class="bg-white p-10 rounded"
    >
      <h3 class="text-lg font-semibold text-blues mb-2">Bulk Upload Form</h3>
      <form @submit.prevent="handleSubmit" ref="clearRef" class="space-y-4">
        <div class="flex flex-col gap-3 w-full">
          <div class="flex justify-between">
            <label for="attachments" class="text-left flex items-center"
              >Bulk Upload <span class="text-red-400"> * </span>
              <div class="relative group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div
                  class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                >
                  Only CSV files in the sample format are allowed.
                </div>
              </div>
            </label>
            <div class="w-[20%] flex justify-center items-center">
              <a
                href="https://al-lms-api.galecta.com/media/bulk_upload.csv"
                download
                class="w-full flex gap-1 items-center justify-center tooltip"
              >
                <img
                  src="@/assets/newd/download.png"
                  alt="download file"
                  class="w-4 h-4 object-contain"
                />
                <span class="tooltiptext text-xs w-full"> Sample File</span>
              </a>
            </div>
          </div>
          <input
            id="source"
            type="file"
            class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
            @change="inputchange"
            required
          />
        </div>
        <div class="flex justify-end">
          <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form>
    </div>

    <div class="mt-10">
      <h2 class="text-lg font-semibold mb-4">Submitted Data</h2>
      <div v-if="submittedData.length > 0" class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200 border">
          <thead class="bg-blues whitespace-nowrap">
            <tr>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                S.NO
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                First Name
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Last Name
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Email
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Mobile
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Program
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Batch
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                 Permanent Registration Number
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                ApplicationNumber
              </th>
              <th class="px-4 py-2 text-left text-sm font-bold text-white">
                Department
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 bg-white">
            <tr v-for="(item, index) in submittedData" :key="index">
              <td class="px-4 py-2 text-sm">{{ (currentPage - 1) * 10 + index + 1 }}</td>
              <td class="px-4 py-2 text-sm">{{ item.first_name }}</td>
              <td class="px-4 py-2 text-sm">{{ item.last_name }}</td>
              <td class="px-4 py-2 text-sm">{{ item.email }}</td>
              <td class="px-4 py-2 text-sm">
                {{ item.phone_number }}
              </td>
              <td class="px-4 py-2 text-sm">{{ item.program }}</td>
              <td class="px-4 py-2 text-sm">{{ item.batch }}</td>
              <td class="px-4 py-2 text-sm">
                {{ item.university_registration_number || "NA" }}
              </td>
              <td class="px-4 py-2 text-sm">
                {{ item.application_number || "NA" }}
              </td>
              <td class="px-4 py-2 text-sm">{{ item.department || "NA" }}</td>
            </tr>
          </tbody>
        </table>


        <div
                class="pb-5 flex items-center justify-center"
              >
                <Pagination :totalPages="totalPages" @page-changed="getList" />
               </div>
      </div>
      <div v-else>No Data Found</div>
    </div>
  </div>
</template>


<script>

import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
        messages: {
          text: "",
          type: "null",
        },
        submittedData: [],
        totalPages: 0,
        currentPage: 1,
    };
  },
  watch: {},

  components: {
    FlashMessage,
    Pagination,
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  async created() {
    this.getList(1);
  },
  mounted() {},
  methods: {

     getList(page) {
      this.currentPage = page;
      axios
        .get(
          `${process.env.VUE_APP_API}/enrollment-list/?Key=${this.userInfo.token_key}&page=${page}`
        )
        .then((response) => {
          if (response) {
            this.totalPages = response.data.total_page;
            this.submittedData = response.data.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleSubmit(el){

      let formData = new FormData();
      // formData.append("title", el.target.elements.file_title.value);
      // formData.append("description", el.target.elements.file_description.value);
      formData.append("file", el.target.elements.source.files[0]);

      axios
        .post(
          `${process.env.VUE_APP_API}/enrollement-bulk-csv-upload/new/?Key=${this.userInfo.token_key}`,
          formData
        )
        .then((response) => {
          if (response.data.status == 200) {
                 this.getList(1);
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
               this.$refs.clearRef.reset();
            }, 1500);
         
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    }

  },
};
</script>

<style scoped>
/* tool tip  */
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 40%;
  /* background-color: #17469E; */
  /* color: #fff; */
  color: #17469e;
  text-align: center;
  border: 1px solid #17469e;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  bottom: -8px;
  left: 20px;
  z-index: 1;
}
.wrapper-class {
  max-width: 200px;
  word-wrap: break-word;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
